import { Component, OnInit, AfterViewInit, Inject, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { AuthService } from 'src/app/feature/auth/services/auth.service';
import { EventService } from '../../core/services/event.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-horizontaltopbar',
  templateUrl: './horizontaltopbar.component.html',
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit {
  @ViewChild('dropdown', { static: false }) dropdown: NgbDropdown;

  element;
  configData;
  userLogin;
  listNotifikasi: any = [];
  unmarked_notifications = 0;
  list_unmark_notifications_id = [];
  max_length_message: number = 70;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private eventService: EventService,
    public authService: AuthService
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
      }
    });
  }

  ngOnInit(): void {
    this.element = document.documentElement;

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3
    };
    this.authService.getProfile().subscribe((user: any) => {
      this.userLogin = user;
    });
    this.getNotifikasi();

  }

  getNotifikasi() {
    this.authService.getNotification({}).subscribe((res: any) => {
      this.listNotifikasi = res.data.list;
      this.unmarked_notifications = res.data.unmarked_notifications;
      this.list_unmark_notifications_id = res.data.list_unmark_notifications_id;
    })
  }

  openNotif(val) {
    if (val.marked == false) {
      this.authService.readNotif({ id: val.id }).subscribe((res: any) => {
        this.getNotifikasi();
        if (res.data) {
          this.goToPage(val);
        }
      });
    } else {
      this.goToPage(val);
    }
  }
  goToPage(val) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(val.url);
    });
    // this.router.navigateByUrl(val.url);
    // this.router.navigate([val.page], { queryParams: { kode: val.kode }, queryParamsHandling: 'merge' });

    // if (val.url != null) {
    //   this.router.navigate([val.url]);
    // } else {

    //   this.router.navigate([val.page], { queryParams: { id: val.reff_id } });
    // }

    // window.location.href = val.url;

  }
  readNotif(val) {
    if (val.seen_by != null || val.seen_by != this.userLogin.id) {
      this.authService.readNotif({ id: val.id }).subscribe((res: any) => {
        if (res.data) {
          this.getNotifikasi();
        }
      });
    }
  }

  readAllNotif() {
    this.authService.readAllNotif({ list_notification_id: this.list_unmark_notifications_id }).subscribe((res: any) => {
      if (res.data) {
        this.getNotifikasi();
      }
    });
  }
  showActionNotif(id) {
    const cardDiv = document.getElementById("card-notif-" + id);
    if (cardDiv) {
      cardDiv.classList.add('notification-hover');
    }
    // const hiddenDiv = document.getElementById("action-notif-" + id);
    // hiddenDiv.style.display = "block";
  }
  hideActionNotif(id) {
    const cardDiv = document.getElementById("card-notif-" + id);
    if (cardDiv) {
      cardDiv.classList.remove('notification-hover');
    }
    // const hiddenDiv = document.getElementById("action-notif-" + id);
    // hiddenDiv.style.display = "none";
  }
  setExpandMessage(val) {
    if (val.url != null) {
      this.dropdown.close(); // Close the dropdown
      this.openNotif(val);
    } else {
      if (typeof (val.is_full) == 'undefined' || val.is_full == false) {
        val.is_full = true;
      } else {
        val.is_full = false;
      }
      if (!val.marked) {
        this.readNotif(val);
      }
    }
    // console.log(val);
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['auth/login']);
  }

  /**
   * On menu click
   */
  onMenuClick(event: any) {
    const nextEl = event.target.nextSibling;
    if (nextEl && !nextEl.classList.contains('show')) {
      const parentEl = event.target.parentNode;
      if (parentEl) { parentEl.classList.remove('show'); }

      nextEl.classList.add('show');
    } else if (nextEl) { nextEl.classList.remove('show'); }
    return false;
  }

  ngAfterViewInit() {
    this.activateMenu();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar() {
    const element = document.getElementById('topnav-menu-content');
    element.classList.toggle('show');
  }

  /**
   * Activates the menu
   */
  private activateMenu() {

    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;

    for (const key in links) {
      // reset menu
      resetParent(links[key]);
    }

    for (const key in links) {
      if (location.pathname === links[key]['pathname']) {
        matchingMenuItem = links[key];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add('active');
              }
            }
          }
        }
      }
    }
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (!document.fullscreenElement && !this.element.mozFullScreenElement && !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
    window.location.reload();
  }
}
